import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { read_cookie, userCookie } from '../helpers/cookieHelper';

export const PrivateRoute = ({ component: Component, ...rest }) => {
	return (
	    <Route {...rest} render={props => (
	        read_cookie(userCookie)
	            ? <Component {...props} />
	            : <Redirect to={
	            	{ pathname: '/login', state: { from: props.location } }} />
	    )} />
	);
}



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js